import { api as axiosApi } from '../../utils/axios';
import { Response } from '../../models/response';
import SnackbarUtils from '../../utils/SnackbarUtils';
import i18n from 'i18next';
import httpApi from '../api/httpApi';
import { AdminBlockUsers } from '../../models/Admin/AdminUsers';

const useAdminApi = () => {
    const ADMIN_USER_URL = 'api/v1/admin/user';
    const ADMIN_USER_ADDRESS_URL = 'api/v1/admin/addresses';
    const ADMIN_ADD_TO_COMPANY = 'api/v1/admin/company/user';
    const ADMIN_BLOCK_USERS = 'api/v1/admin/company/tilt';

    const handleErrorRequest = (error) => {
        if (error.data && error.data.errors) {
            const errorKey = Object.keys(error.data.errors)[0];
            const firstError = error.data.errors[errorKey][0];
            const errorKeyString =
                'ERROR.REGISTRATION_ERRORS.' +
                errorKey.toUpperCase() +
                '.' +
                firstError.toUpperCase();
            if (
                i18n.exists(errorKeyString, {
                    ns: 'errors',
                })
            ) {
                SnackbarUtils.error(i18n.t(errorKeyString, { ns: 'errors' }));
            } else {
                SnackbarUtils.error(error.data.message);
            }
        }
    };

    const sendPartnerRegistration = (data) => {
        return axiosApi
            .post<PartnerRegistrationRequest>(ADMIN_USER_URL, data)
            .then((resp) => {
                return Response.createSuccessful<PartnerRegistrationRequest>(
                    resp.data,
                    resp.status
                );
            })
            .catch((error: { data: any; status: number }) => {
                handleErrorRequest(error);

                throw error;
            });
    };

    const updateUser = (data, userId) => {
        return axiosApi
            .put<PartnerRegistrationRequest>(
                ADMIN_USER_URL + '/' + userId,
                data
            )
            .then((resp) => {
                return Response.createSuccessful<PartnerRegistrationRequest>(
                    resp.data,
                    resp.status
                );
            })
            .catch((error: { data: any; status: number }) => {
                handleErrorRequest(error);

                throw error;
            });
    };

    const updateUserAddress = (data, userId, locationId) => {
        return axiosApi
            .put<PartnerRegistrationRequest>(
                ADMIN_USER_ADDRESS_URL + '/' + userId + '/' + locationId,
                data
            )
            .then((resp) => {
                return Response.createSuccessful<PartnerRegistrationRequest>(
                    resp.data,
                    resp.status
                );
            })
            .catch((error: { data: any; status: number }) => {
                handleErrorRequest(error);

                throw error;
            });
    };

    const addToCompany = (data) => {
        return httpApi
            .post<any>(ADMIN_ADD_TO_COMPANY, data)
            .then((resp) => {
                return resp.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const blockAllUser = (data: AdminBlockUsers) => {
        return httpApi
            .post<any>(ADMIN_BLOCK_USERS, data)
            .then((resp) => {
                return resp.getData();
            })
            .catch((error) => {
                throw error;
            });
    }

    return {
        sendPartnerRegistration,
        updateUser,
        updateUserAddress,
        addToCompany,
        blockAllUser,
    };
};

export default useAdminApi;

export type PartnerRegistrationRequest = {
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    company: string;
    tax_number: string;
    default_stock: string;
    // password: string;
    // password_confirmation: string;
    // terms_of_service: boolean;
    // has4322: boolean;
    country: string;
    postcode: string;
    city: string;
    address1: string;
    address2: string;
    note: string;
    bc_customer_no: string;
    bc_company_number: string;
};
